import { FC } from 'react';
import { Row } from 'reactstrap';

const skeletonStyle: React.CSSProperties = {
	height: '80px',
	width: '100%',
	marginBottom: '12px'
};

export const SkeletonRequestFiles: FC = () => {
	return (
		<Row>
			{Array.from({ length: 2 }).map((_, idx) => (
				<div
					key={idx}
					className="skeletonStyle"
					style={skeletonStyle}
				/>
			))}
		</Row>
	);
};
